import { motion, type Variants } from "framer-motion";
import styled from "styled-components";
import { theme } from "../../theme";

export const PanelAnchor = styled.div`
  position: relative;
  overflow: visible;
`;

export const SlidePanel = styled(motion.div)<{ direction: "up" | "down" }>`
  position: absolute;
  transform-origin: ${({ direction }) =>
    direction === "up" ? "bottom" : "top"};
  ${({ direction }) =>
    direction === "up"
      ? `bottom: 38px; border-radius: 12px 12px 0 0; border-bottom: none; box-shadow: 0px -4px 24px rgba(0, 0, 0, 0.12);`
      : `top: 38px; border-radius: 0 0 12px 12px; box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.12);`}
  left: 4px;
  right: 4px;
  padding: 16px;
  z-index: 1;
  background-color: ${theme.colors.grey02};
  border: 1px solid ${theme.colors.border};
  box-sizing: border-box;
`;

export const PanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const HighligtActionButton = styled.button`
  border: none;
  background-color: transparent;
  display: flex;
  gap: 4px;
  align-items: center;
  padding: 0;
  outline: none;
  cursor: pointer;
  border-bottom: 1px solid transparent;

  &:hover {
    border-bottom: 1px solid ${theme.colors.text};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    border-bottom: 1px solid transparent;
  }
`;

export const PanelCloseButton = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    filter: brightness(40%);
  }
`;

export const panelUpVariants: Variants = {
  hidden: { clipPath: "inset(100% 0 0 0)" },
  visible: {
    clipPath: "inset(0% 0 0 0 round 12px 12px 0 0)",
    transition: { type: "spring", damping: 28, stiffness: 300 },
  },
  exit: { clipPath: "inset(100% 0 0 0)", transition: { duration: 0.15 } },
};

export const panelDownVariants: Variants = {
  hidden: { clipPath: "inset(0 0 100% 0)" },
  visible: {
    clipPath: "inset(0 0 0% 0 round 0 0 12px 12px)",
    transition: { type: "spring", damping: 28, stiffness: 300 },
  },
  exit: { clipPath: "inset(0 0 100% 0)", transition: { duration: 0.15 } },
};
